export const logDebug = console.log // tslint:disable-line

export const logError = console.error // tslint:disable-line

export const logWarn = console.warn // tslint:disable-line
